import { render } from "./Effect.vue?vue&type=template&id=b5f0f05a&scoped=true"
const script = {}

import "./Effect.vue?vue&type=style&index=0&id=b5f0f05a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5f0f05a"]])

export default __exports__